export const locales = [
  'ca', 'da', 'de', 'en', 'es', 'eu', 'fr', 'gl', 'it', 'nl',
  'pl', 'pt', 'sv', 'ar', 'hi', 'ja', 'ko', 'ru', 'uk', 'zh'
] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = 'es';

export const localeNames: Record<Locale, string> = {
  ca: 'Català',
  da: 'Dansk',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  eu: 'Euskara',
  fr: 'Français',
  gl: 'Galego',
  it: 'Italiano',
  nl: 'Nederlands',
  pl: 'Polski',
  pt: 'Português',
  sv: 'Svenska',
  ar: 'العربية',
  hi: 'हिन्दी',
  ja: '日本語',
  ko: '한국어',
  ru: 'Русский',
  uk: 'Українська',
  zh: '中文',
};

export const localeFlags: Record<Locale, string> = {
  ca: '🏳️',
  da: '🇩🇰',
  de: '🇩🇪',
  en: '🇬🇧',
  es: '🇪🇸',
  eu: '🏳️',
  fr: '🇫🇷',
  gl: '🏳️',
  it: '🇮🇹',
  nl: '🇳🇱',
  pl: '🇵🇱',
  pt: '🇵🇹',
  sv: '🇸🇪',
  ar: '🇸🇦',
  hi: '🇮🇳',
  ja: '🇯🇵',
  ko: '🇰🇷',
  ru: '🇷🇺',
  uk: '🇺🇦',
  zh: '🇨🇳',
};

// Languages available for tour creation (same 20)
export const tourLanguages = locales.map(code => ({
  code,
  name: localeNames[code],
  flag: localeFlags[code],
}));
